import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Send } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message envoyé ! Merci, nous vous répondrons bientôt.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("Une erreur est survenue. Réessayez plus tard.");
    } finally {
      setSending(false);
    }
  };

  const inp = "w-full px-5 py-4 rounded-2xl border-2 border-[var(--agt-line)] bg-white focus:outline-none focus:border-[var(--agt-mustard)] focus:ring-2 focus:ring-[var(--agt-mustard)]/20 transition-colors text-base font-medium";

  return (
    <main className="max-w-3xl mx-auto px-6 md:px-8 py-14 md:py-20" data-testid="contact-page">
      <span className="eyebrow">Nous écrire</span>
      <h1 className="font-heading mt-4 text-[var(--agt-navy)]" style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)" }}>Contact.</h1>
      <p className="mt-6 text-lg text-[var(--agt-ink-muted)] max-w-xl leading-relaxed">Une question, une suggestion, une correction à apporter ? Écrivez-nous, on vous répond vite.</p>

      <form onSubmit={onSubmit} className="mt-12 grid gap-5">
        <div className="grid md:grid-cols-2 gap-5">
          <div>
            <label className="eyebrow-navy text-[0.6rem] mb-2 block">Nom</label>
            <input required data-testid="contact-name" className={inp} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}/>
          </div>
          <div>
            <label className="eyebrow-navy text-[0.6rem] mb-2 block">Email</label>
            <input required type="email" data-testid="contact-email" className={inp} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}/>
          </div>
        </div>
        <div>
          <label className="eyebrow-navy text-[0.6rem] mb-2 block">Sujet</label>
          <input required data-testid="contact-subject" className={inp} value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}/>
        </div>
        <div>
          <label className="eyebrow-navy text-[0.6rem] mb-2 block">Message</label>
          <textarea required rows={6} data-testid="contact-message" className={inp} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}/>
        </div>
        <button type="submit" disabled={sending} className="btn-primary self-start disabled:opacity-60" data-testid="contact-submit">
          <Send className="w-4 h-4"/> {sending ? "Envoi…" : "Envoyer le message"}
        </button>
      </form>
    </main>
  );
}
